import * as React from "react";
function SvgTelevision(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={32} height={32} fill="#d1458f" rx={6} ry={6} />
      <path
        fill="#fff"
        d="M9.87 24.25A9.64 9.64 0 0116 22.19a9.64 9.64 0 016.13 2.06h1.93A10.5 10.5 0 0016 20.81a10.5 10.5 0 00-8.06 3.44z"
      />
      <path
        fill="#fff"
        d="M26.31 21.5H5.69a.69.69 0 01-.69-.69V8.44a.69.69 0 01.69-.69h20.62a.69.69 0 01.69.69v12.37a.69.69 0 01-.69.69zM9.12 12.34h2.07v6.41h2.31v-6.41h2.06V10.5H9.12zm13.76-1.84h-2.22l-1 4.21c-.06.22-.12.53-.2.93a9.71 9.71 0 00-.13 1 15.76 15.76 0 00-.33-1.95l-1-4.19h-2.25l2.4 8.25h2.33z"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgTelevision);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
